import Add from "../../table/Add";
import ApiService from "../../../services/apiService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { addChackInstrument,chackInstrumentTitle } from "../../../constants";


const AddChackInstrumentDetail = () =>{
    const navigate = useNavigate();
    const [chackData, setChackData] = useState<any>([]);

         const handleSubmit = async (data: any) =>{
            try{
                const response = await ApiService.axiosApi(`/chackinstrumentdetail`,{
                    method: 'Post',
                    data: data
                });
                if(response.success){
                    toast.success(response.message || "Chack Instrument Detail Added Successfully")
                    navigate(-1)
                }else{
                    toast.error(response.message || "Failed to add Chack Instrument Detail")
                }
            }catch(error: any){
                toast.error(error.message || "Failed to add Chack Instrument Deatil")
            }
        }

        useEffect(()=>{
            const fetchChackData = async ()=>{              
                try{
                    const response = await ApiService.axiosApi(`/chack`,{
                        method: 'GET'
                    });
                    if(response.success){
                        setChackData(response.data.data);
                    }
                }catch(error:any){
                toast.error(error.message || "Failed to fetch Chack Data");
            }   }
            fetchChackData();
        },[]);  
   

    return(
        <>
         <Add
        title={addChackInstrument}
        parentTitle={chackInstrumentTitle}
        onSubmit={handleSubmit}
        fields={[
            {
                name: "Instrument",
                label: "Instrument",
                type: "text",
                validation: { required: "Chack Instrument Detail is required" }
            },
            {
                name : "Make",
                label : "Make",
                type : "text",
                validation : "  Make is required"

            },
            {
                name : "Model",
                label: "Model",
                type : "text",
                validation : "Model is required"
            },
            {
                name : "InstallationReplacementDate",
                label : "Installation/Replacement Date",
                type : "text",
                validation : "Installation Replacemnt Date required is required"
            },
            {
                name:"Remark",
                label:"Remark",
                type:"text",
                vaildation:"Remark is required"
            },
            {
                name:"Chack",
                label:"Chack",
                isDropdown:true,
                dropdownData:chackData,
                dropdownLabel:"chackName",
                idFieldName:"chackId"

            },
            

        ]}
        />
 
        </>
          )
}

export default AddChackInstrumentDetail;